/* global angular */
( function () {
	'use strict';

	function obsStatusReportPdf ( moment, pdfCommonFactory ) {
		var self = this;

		self.firstPage = false;

		function generateFrontPageDetails ( filters ) {
			var section = {
				'stack' : [
					{
						'columns' : [
							{
								'text'      : 'Search Criteria',
								'width'     : '25%',
								'alignment' : 'right'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'District Name ',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.district,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Type(s) ',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.types,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Date Range From ',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : moment( filters.dateRange.startDate ).format( 'MM/DD/YY' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Date Range To',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : moment( filters.dateRange.endDate ).format( 'MM/DD/YY' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Location(s) ',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.school,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Observer ',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.observer,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Invitee(s) ',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : filters.invitees,
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}, {
						'columns' : [
							{
								'text'  : 'Report Generated On',
								'style' : 'frontPageHeaderKey',
								'width' : '25%'
							}, {
								'text'  : moment( new Date() ).format( 'MM/DD/YY h:mm A' ),
								'style' : 'frontPageHeaderValue',
								'width' : '75%'
							}
						]
					}
				]
			};

			return section;
		}

		function generateObsStatusBody ( schoolData ) {
			var bodyData = schoolData.map( function ( observation ) {
				var obsStatusItemList = [ {
					'columns' : [ {
						'text'  : 'Observation Title',
						'style' : 'frontPageHeaderKey',
						'width' : '20%'
					}, {
						'text'  : observation.name || 'N/A',
						'style' : 'frontPageHeaderValue',
						'width' : '75%'
					} ]
				}, {
					'columns' : [ {
						'text'  : 'District',
						'style' : 'frontPageHeaderKey',
						'width' : '20%'
					}, {
						'text'  : observation.district,
						'style' : 'frontPageHeaderValue',
						'width' : '75%'
					} ]
				}, {
					'columns' : [ {
						'text'  : 'Invitee',
						'style' : 'frontPageHeaderKey',
						'width' : '20%'
					}, {
						'text'  : observation.observee || 'N/A',
						'style' : 'frontPageHeaderValue',
						'width' : '75%'
					} ]
				}, {
					'columns' : [ {
						'text'  : 'Observer',
						'style' : 'frontPageHeaderKey',
						'width' : '20%'
					}, {
						'text'  : observation.observer || 'N/A',
						'style' : 'frontPageHeaderValue',
						'width' : '75%'
					} ]
				}, {
					'columns' : [ {
						'text'  : 'Completed PD',
						'style' : 'frontPageHeaderKey',
						'width' : '20%'
					}, {
						'text'  : observation.completedPd || 'N/A',
						'style' : 'frontPageHeaderValue',
						'width' : '75%'
					} ]
				}, {
					'text' : '\n\n'
				} ];

				return {
					'stack' : obsStatusItemList
				};
			} );

			return {
				'stack' : bodyData
			};
		}

		function mapSchools ( school ) {
			var item            = this.item;
			var status          = this.status;
			var obsStatusHeader = {
				'columns' : [
					{
						'text'  : 'Observation Status : ' + Object.keys( item ),
						'style' : 'ObsStatusUserReportHeader'
					}, {
						'text'  : 'Location : ' + school,
						'style' : 'ObsStatusUserReportHeader'
					}
				]
			};

			var schoolData     = item[ status ][ school ];
			var obsStatusEntry = {
				'stack' : [ obsStatusHeader,
					pdfCommonFactory.horizontalRule( 1, [ 0, 0, 0, 0 ] ),
					generateObsStatusBody( schoolData )
				],

				'pageBreak' : self.firstPage && 'before'
			};

			self.firstPage = true;

			return obsStatusEntry;
		}

		function mapStatus ( status ) {
			var item = this.item;

			return Object.keys( item[ status ] ).map( mapSchools.bind( {
				'item'   : item,
				'status' : status
			} ) );
		}

		function mapObjStatus ( item ) {
			var statusSet = Object.keys( item ).map( mapStatus.bind( { 'item' : item } ) );

			return [].concat.apply( [], statusSet );
		}

		function generateBody ( data ) {
			var obsSet     = ( data || [] ).map( mapObjStatus );

			// set self.firstPage to its original state every after building the report body
			self.firstPage = false;
			return {
				'stack' : [].concat.apply( [], obsSet )
			};
		}

		function mapStatisticsSchool ( school ) {
			var status     = this.status;
			var statusText = Object.keys( status );

			return {
				'columns' : [
					{
						'text'  : school,
						'style' : 'ObsStatusStatisticsBody'
					}, {
						'text'  : String( status[ statusText ][ school ].length ),
						'style' : 'ObsStatusStatisticsBody'
					}
				],

				'amount' : status[ statusText ][ school ].length
			};
		}

		function reduceToTotal ( previous, current ) {
			return { 'amount' : previous.amount + current.amount };
		}

		function mapStatisticsStatus ( status ) {
			var statItem = {
				'stack' : []
			};

			var statusText  = Object.keys( status );
			var statBody    = Object.keys( status[ statusText ] ).map( mapStatisticsSchool.bind( { 'status' : status } ) );
			var total       = statBody.reduce( reduceToTotal );
			var statsHeader = {
				'columns' : [
					{
						'text'  : 'Observations ' + statusText,
						'style' : 'ObsStatusUserReportHeader',
						'width' : '50%'
					}, {
						'text'  : String( total.amount ),
						'style' : 'ObsStatusUserReportHeader',
						'width' : '50%'
					}
				]
			};

			statItem.stack = [ statsHeader, pdfCommonFactory.horizontalRule( 2, [ 0, 0, 0, 0 ] ), statBody ];
			return statItem;
		}

		function generateSummary ( data ) {
			return data.map( mapStatisticsStatus );
		}

		function buildSummaryPage ( filters, data ) {
			return {
				'stack' : [
					pdfCommonFactory.createHeader( filters.templateTitle ),
					pdfCommonFactory.horizontalRule( 2, [ 0, 0, 0, 0 ] ),
					generateSummary( data )
				],

				'pageBreak' : 'before'
			};
		}

		function generateFrontPage ( filters ) {
			var sections = {
				'stack' : [ pdfCommonFactory.createHeader( filters.templateTitle ),
					pdfCommonFactory.horizontalRule( 2, [ 0, 0, 0, 0 ] ),
					generateFrontPageDetails( filters )
				]
			};

			return sections;
		}

		function buildReport ( obsList, filters ) {
			var sections = {
				'stack' : [
					pdfCommonFactory.createHeader( filters.templateTitle ),
					pdfCommonFactory.horizontalRule( 2, [ 0, 0, 0, 0 ] ),
					generateBody( obsList )
				],

				'pageBreak' : 'before'
			};

			return sections;
		}

		return {
			'buildReport'       : buildReport,
			'generateFrontPage' : generateFrontPage,
			'buildSummaryPage'  : buildSummaryPage
		};
	}

	angular.module( 'app.components' )
		.factory( 'obsStatusReportPdf', obsStatusReportPdf );

	obsStatusReportPdf.$inject = [ 'moment', 'pdfCommonFactory' ];
} )( );
